<template>
    <div class="Checkbox"
         @keyup.space="onFocus">
        <input class="form-control checkbox"
               :id="id"
               :disabled="disabled"
               :checked="checked"
               type="checkbox"/>
        <span class="checkmark"
              :class="{disabled}"
              @click="onFocus"
              :style="{background: transparent ? 'transparent' : 'white'}"></span>
        <span class="checkbox-description"
              :class="{disabled}"
              @click="onFocus">
            <slot></slot>
        </span>
    </div>
</template>

<script>
    export default {
        name: 'Checkbox',
        props: {
            id: Number,
            transparent: Boolean,
            checked: Boolean,
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                value: ''
            }
        },
        watch: {
            checked() {
                this.value = this.checked;
            },
            disabled: {
                handler() {
                    this.value = false;
                },
                immediate: true
            }
        },
        methods: {
            onFocus() {
                if (!this.disabled) {
                    this.value = !this.value;
                    this.$emit('update:checked', this.value);
                }
            }
        },
        mounted() {
           this.value = this.checked;
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/colors";

    .Checkbox {
        position: relative;
        display: flex;
        align-items: center;
        position: relative;
        padding-left: 35px;
        cursor: pointer;
        user-select: none;
    }

    .Checkbox input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    span.checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 18px;
        width: 18px;
        background-color: $White;
        border: 2px solid $ComplementaryBgTxtDarker;
        &:hover {
            background-color: $ComplementaryBackgroundLightGrey !important;
        }
    }

    .Checkbox input:checked ~ .checkmark {
        background-color: $LightBlue !important;
        border: 2px solid $LightBlue;
    }

    .Checkbox input:disabled ~ .checkmark {
        background-color: $ComplementaryBgTxtDarker !important;
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .Checkbox input:checked ~ .checkmark:after {
        display: block;
    }

    .Checkbox .checkmark:after {
        left: 3px;
        top: -1px;
        width: 8px;
        height: 12px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
    .checkbox-description {
        margin-left: -3px;
        font-size: 15px !important;
        color: $Dark;
        &.disabled {
            color: $GreyOpacity !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/controls/Checkbox.vue